import { TimePicker } from 'antd';
import type { TimePickerProps } from 'antd';
import { forwardRef } from 'react';
import {
  controlSizeForContext,
  CONTROL_CLASS,
} from '@/theme/controlSizing';
import type { ControlContext } from '@/theme/controlSizing';

/**
 * Format jam default Booku V2 — `HH:mm`.
 */
export const DEFAULT_TIME_FORMAT = 'HH:mm';

/**
 * Props {@link TimePickerBox}.
 */
export interface TimePickerBoxProps extends Omit<TimePickerProps, 'size'> {
  /** Konteks pemakaian — menentukan density. Default: `form`. */
  context?: ControlContext;
  /** Override paksa size Antd jika perlu. */
  size?: TimePickerProps['size'];
}

/**
 * Time picker — wrapper Antd TimePicker.
 *
 * Sifat sama dengan {@link DatePickerBox} (density via `context`, width 100%,
 * class `booku-control`). Format default `HH:mm` (24-jam).
 *
 * Pemakaian:
 * ```tsx
 * <TimePickerBox value={jam} onChange={setJam} />
 * ```
 *
 * Dokumentasi pattern: `.claude/docs/Booku v2/ui-patterns/control-system-pattern.md`
 */
export const TimePickerBox = forwardRef<
  React.ComponentRef<typeof TimePicker>,
  TimePickerBoxProps
>(function TimePickerBox(
  { context = 'form', size, format, style, className, ...rest },
  ref
) {
  const resolvedSize = size ?? controlSizeForContext(context);
  return (
    <TimePicker
      ref={ref}
      size={resolvedSize}
      format={format ?? DEFAULT_TIME_FORMAT}
      className={`${CONTROL_CLASS}${className ? ` ${className}` : ''}`}
      style={{ width: '100%', ...style }}
      {...rest}
    />
  );
});
